import React from 'react';

export const DownloadPdfFundElection = ({ blobPdf }) => {
  const fileURL = window.URL.createObjectURL(blobPdf);

  return (
    <a download="Fund name and default primary elections changes.pdf" href={fileURL}>
      <i className="bi bi-cloud-arrow-down-fill text-dark" />
    </a>
  );
};
